<script setup lang="ts">
import { computed, onMounted } from 'vue';
import { EntityListPage, getAggregatorsLookup, getMessageTypesLookup, type EntityConfig } from '@botto/core';
import { messageTemplatesStore } from '../../api';
import type { MessageTemplate } from '../../api';

const aggregatorsLookup = getAggregatorsLookup();
const messageTypesLookup = getMessageTypesLookup();

onMounted(() => {
  void Promise.all([aggregatorsLookup.ensureLoaded(), messageTypesLookup.ensureLoaded()]);
});

const config = computed<EntityConfig<MessageTemplate>>(() => ({
  title: 'Шаблон сообщения',
  titlePlural: 'Шаблоны сообщений',
  popupWidth: 640,
  popupHeight: 600,
  columns: [
    { dataField: 'id', caption: 'ID', dataType: 'number', width: 80 },
    { dataField: 'name', caption: 'Название' },
    {
      dataField: 'aggregator_id',
      caption: 'Агрегатор',
      dataType: 'number',
      calculateDisplayValue: (row) => aggregatorsLookup.labelOf(row.aggregator_id),
    },
    {
      dataField: 'message_type_id',
      caption: 'Тип сообщения',
      dataType: 'number',
      width: 200,
      calculateDisplayValue: (row) => messageTypesLookup.labelOf(row.message_type_id),
    },
    { dataField: 'template', caption: 'Шаблон' },
  ],
  fields: [
    { dataField: 'id', label: 'ID', editOnly: true, editorOptions: { readOnly: true } },
    { dataField: 'name', label: 'Название' },
    { dataField: 'aggregator_id', label: 'Агрегатор', required: true, lookup: aggregatorsLookup },
    {
      dataField: 'message_type_id',
      label: 'Тип сообщения',
      required: true,
      lookup: messageTypesLookup,
    },
    {
      dataField: 'template',
      label: 'Текст шаблона',
      required: true,
      editorType: 'dxTextArea',
      editorOptions: { height: 180, autoResizeEnabled: true },
    },
  ],
}));
</script>

<template>
  <EntityListPage :config="config" :store="messageTemplatesStore" />
</template>
